import type { ComponentProps, ReactNode } from 'react'

import { Typography } from '@twisto/components/atoms/typography'

import { BaseButton } from '../base-button'

import * as styles from './inline-button.styles'
import type { Colors } from './inline-button.styles'

type Props = {
  color?: Colors
  fullWidth?: boolean
  noTypography?: boolean
  children: ReactNode
  onClick: () => void
} & ComponentProps<typeof BaseButton>

export const InlineButton = ({
  color = 'secondary',
  fullWidth = false,
  noTypography = false,
  children,
  onClick,
  ...buttonProps
}: Props) => (
  <BaseButton
    css={[styles.root, styles.colors[color], fullWidth && styles.fullWidth]}
    data-testid="inline-button"
    onClick={onClick}
    {...buttonProps}
  >
    {noTypography ? (
      <>{children}</>
    ) : (
      <Typography component="span" fontWeight="medium" variant="b2">
        {children}
      </Typography>
    )}
  </BaseButton>
)
